import { render } from "./CompaniaBaremosTrabajos.vue?vue&type=template&id=de8a1b8a&scoped=true"
import script from "./CompaniaBaremosTrabajos.vue?vue&type=script&lang=js"
export * from "./CompaniaBaremosTrabajos.vue?vue&type=script&lang=js"

import "./CompaniaBaremosTrabajos.vue?vue&type=style&index=0&id=de8a1b8a&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8a1b8a"]])

export default __exports__